export default "__VITE_ASSET__DJx_ka0a__"